import { render, staticRenderFns } from "./shortText.vue?vue&type=template&id=d745a4f8&"
import script from "./shortText.vue?vue&type=script&lang=js&"
export * from "./shortText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports